const cuppingReportData = JSON.parse(
  document.querySelector("#CuppingReportData").innerHTML
);

const data = {
  labels: cuppingReportData.labels,
  datasets: [
    {
      label: cuppingReportData.datasets[0].label, //"Cupping Report",
      data: cuppingReportData.datasets[0].data, //[(65, 59, 90, 81, 56, 55, 40)],
      fill: true,
      backgroundColor: "rgba(77, 166, 92, 0.35)",
      borderColor: "rgba(62, 112, 64, 1)",
      pointBackgroundColor: "rgba(62, 112, 64, 1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(62, 112, 64, 1)",
    },
  ],
};

const config = {
  type: "radar",
  data: data,
  options: {
    plugins: {
      tooltip: {
        enabled: false,
      },
      legend: {
        display: false,
      },
    },
    scales: {
      r: {
        // beginAtZero: true,
        suggestedMax: 10,
        suggestedMin: 4,
        ticks: {
          stepSize: 1,
          display: false,
        },
        pointLabels: {
          font: {
            size: 11,
            weight: 700,
            color: "rgba(55, 56, 58, 1)",
          },
        },
      },
    },
    elements: {
      line: {
        borderWidth: 3,
        pointStyle: false,
      },
    },
  },
};

// render init block
const myChart = new Chart(document.getElementById("acquisitions"), config);

// Instantly assign Chart.js version
// const chartVersion = document.getElementById("chartVersion");
// chartVersion.innerText = Chart.version;
